import { Button, Text } from '@chakra-ui/react'
import { useRouter } from 'next/router'

import useAPIWrapper from '@/client/hooks/useAPIWrapper'
import { getTutorOfferingPageUrl } from '@/client/services/url'
import { SAT_BOOTCAMP_WORLD_SLUG } from '@/client/services/worlds'

import ModalV3 from '@/components/UI/Modal/ModalV3'

const HOST_BOOTCAMP_URL = getTutorOfferingPageUrl({
  type: 'program',
  slug: SAT_BOOTCAMP_WORLD_SLUG,
})

// If the user was leveled up to a 'tutor' in SAT Bootcamp subworld during
// the current SAT Test phase, then show the 'Publish Bootcamp' modal
export default function PublishBootcampOnLevelUpModal({
  onAcknowledgment,
}: {
  onAcknowledgment: () => Promise<void>
}): JSX.Element | null {
  const router = useRouter()

  const [onContinue, isContinuing] = useAPIWrapper(
    async () => {
      await onAcknowledgment()
      await router.push(HOST_BOOTCAMP_URL)
    },
    [onAcknowledgment, router],
    'Continue to create bootcamp after leveling up to tutor'
  )

  return (
    <ModalV3
      open
      title="It's time to publish your bootcamp!"
      body={() => (
        <Text>
          Congrats on becoming a tutor in the SAT Bootcamp subworld! You&apos;ve now unlocked the
          ability to publish your own bootcamp. It only takes a few minutes! 🎉
        </Text>
      )}
      rightFooterContent={() => (
        <Button isLoading={isContinuing} onClick={onContinue}>
          Let&apos;s Go!
        </Button>
      )}
      disableClickOutside
      onClose={onAcknowledgment}
    />
  )
}
